import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Disease, PetDetail, PetType, Vaccine } from '../../interfaces/pet';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { DataMappingService } from '../../services/data-mapping.service';
import { JsonDataService } from '../../services/json-data.service';
import { OwnerDetail } from '../../interfaces/owner';
import { PetService } from '../../services/pet.service';
import { Subject } from 'rxjs';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment.prod';
import { logFormData, logFormDataPretty } from '../../utils/form-util';

// import { KycService } from 'src/app/services/kyc/kyc-service';
// import { WinNotificationService } from 'src/app/services/win-notification.service';

@Component({
  selector: 'app-pet-detail',
  templateUrl: './pet-detail.component.html',
  styleUrls: ['./pet-detail.component.scss']
})
export class PetDetailComponent implements OnInit {
  // @ViewChild('newModal') public newModal: ModalDirective;
  modalRef: BsModalRef;
  selectedPet: any;
  title?: string;
  closeBtnName?: string;
  isNew = false;
  petDetailForm: FormGroup;
  petDetailData = new FormData();
  ownerList: OwnerDetail[] = [];
  ownerNameList: string[] = [];
  ownerFirstNameList: string[] = [];
  ownerLastNameList: string[] = [];
  isOwnerListLoaded = false;
  selectedOwner = {} as OwnerDetail;
  diseases: Disease[] = [];
  availableDiseases: Disease[] = [];
  selectedDisease = {} as Disease;
  vaccines: Vaccine[] = [];
  availableVaccines: Vaccine[] = [];
  selectedVaccine = {} as Vaccine;

  selectedDiseases = [] as Disease[];
  selectedVaccines = [] as Vaccine[];
  isSavingPet = false;

  petTypes = [] as PetType[];
  selectedPetType = {} as PetType;

  public onClose = new Subject<boolean>();
  nationalityList: string[] = [];
  selectedNationality = '';
  selected_vaccination_proof_file: File | null = null;
  vaccinationProofUrl = '';
  selectedReferral = '';
  selectedSex = '';
  selectedIsFriendly = '';
  selectedIsSensitiveBodyOrPhysicalRestriction = '';
  selectedIsSkinProblems = '';
  selectedIsTicksFleesTreated = '';
  selectedIsRecentlyDeWormed = '';
  selectedIsSpecialDietaryRequirements = '';
  selectedIsIllLast30Days = '';
  selectedIsMedicalConditionsInjuriesIllnesses = '';
  selectedIsAllergiesFoodSensitivities = '';
  hasEditPermission: boolean = false;
  hasAddPermission: boolean = false;
  previewUrl: string | null = null;
  apiUrl = '';


  constructor(
    private petService: PetService,
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private jsonDataService: JsonDataService,
    private dataMappingService: DataMappingService,
    private toastr: ToastrService,
  ) {
    // this.createPetDetailForm();
    this.nationalityList = this.jsonDataService.jsonNationality;
    this.petDetailForm = this.formBuilder.group({
      ownerFirstName: '',
      ownerLastName: '',
      petType: '',
      code: '',
      name: '',
      sex: '',
      age: [''],
      breed: [''],
      isSpayedNeutered: [''],
      lastHeatDate: [''],
      isFriendly: [''],
      isSensitiveBodyOrPhysicalRestriction: [''],
      sensitiveBodyOrPhysicalRestrictionDetails: [''],
      weight: '',
      diseaseName: '',
      vaccineName: '',
      isFullyVaccinated: [''],
      vaccinatedProof: [null],
      isRabiesVaccinated: [''],
      isSkinProblems: [''],
      isTicksFleesTreated: [''],
      ticksFleesTreatedDate: [''],
      ticksFleesTreatedHowTo: [''],
      isRecentlyDeWormed: [''],
      recentlyDeWormedDate: [''],
      isSpecialDietaryRequirements: [''],
      specialDietaryRequirementsDescription: [''],
      isIllLast30Days: [''],
      illLast30DaysExplanation: [''],
      isDisplayingSymptomsCoughingSneezingUpsetStomach: [''],
      isMedicalConditionsInjuriesIllnesses: [''],
      medicalConditionsInjuriesIllnessesDetails: [''],
      isAllergiesFoodSensitivities: [''],
      allergiesFoodSensitivitiesDetails: [''],
      isAllowedPhotoVideoUsage: [''],
      image: [null],
      imageFileName: [''],
    });

    this.setFormFieldsSelectedValue();
    this.modalRef = bsModalRef;
  }

  ngOnInit(): void {
    this.apiUrl = this.petService.getApiUrl();
    // this.getOwners();
    this.processOwnerList(this.ownerList)
    this.getAvailableDiseases();
    this.getAvailableVaccines();

    // this.getDiseases();
    // this.getVaccines();
    // this.getPetTypes();
    this.setPetType();

    console.log(`Pet-detail, ngOnInit, selectedPet: ${JSON.stringify(this.selectedPet)}`);
    // this.list.push('PROFIT!!!');
    if (!this.isNew) {
      this.patchPetDetailForm(this.selectedPet);
      if (this.selectedPet.owner) {
        this.selectedOwner = this.selectedPet.owner;
      }
      if (this.selectedPet.diseases) {
        this.selectedDiseases = this.selectedPet.diseases;
      }
      if (this.selectedPet.vaccines) {
        this.selectedVaccines = this.selectedPet.vaccines;
      }

      if (this.selectedPet.image){
        console.log(`PetDetail, ngOnInit, apiUrl: ${this.apiUrl}`);
        this.previewUrl = this.selectedPet.image ? `${this.apiUrl}${this.selectedPet.image}` : null;
      }

      this.hasEditPermission = this.petService.hasPermission('api.change_pet');
      console.log(`PetDetail, ngOnInit, hasEditPermission: ${this.hasEditPermission}`);

      this.disableForm();
    }
    else {
      this.hasAddPermission = this.petService.hasPermission('api.add_pet');
      console.log(`PetDetail, ngOnInit, hasAddPermission: ${this.hasAddPermission}`);
    }
  } // end of ngOnInit

  savePetDetail() {
    console.log(`savePetDetail`);
    this.createPetDetailPayload();
    // logFormData(this.petDetailData);
    logFormDataPretty(this.petDetailData);
    console.log(`savePetDetail petDetailData: ${this.petDetailData}`);

    if (this.isNew) {
      console.log(`savePetDetail create pet`);
      this.createPet();
    } else {
      console.log(`savePetDetail update Pet`);
      this.updatePetDetail();
    }
    // this.hideModal(true);
  } // end of savePetDetail

  patchPetDetailForm(pet: PetDetail) {
    this.petDetailForm.patchValue({
      ownerFirstName: pet.owner?.firstName,
      ownerLastName: pet.owner?.lastName,
      code: pet.code,
      name: pet.name,
      sex: pet.sex,
      lastHeatDate: pet.lastHeatDate,
      age: pet.age,
      breed: pet.breed,
      isSpayedNeutered: this.convertBooleanToYesNo(pet.isSpayedNeutered),
      isFriendly: this.convertBooleanToYesNo(pet.isFriendly),
      isSensitiveBodyOrPhysicalRestriction: this.convertBooleanToYesNo(pet.isSensitiveBodyOrPhysicalRestriction),
      sensitiveBodyOrPhysicalRestrictionDetails: pet.sensitiveBodyOrPhysicalRestrictionDetails,
      weight: pet.weight,
      isAllowedPhotoVideoUsage: this.convertBooleanToYesNo(pet.isAllowedPhotoVideoUsage),
      diseaseName: '',
      vaccineName: '',
      isFullyVaccinated: this.convertBooleanToYesNo(pet.healthHistory?.isFullyVaccinated),
      vaccinatedProof: pet.healthHistory?.vaccinationProof,
      isRabiesVaccinated: this.convertBooleanToYesNo(pet.healthHistory?.isRabiesVaccinated),
      isSkinProblems: this.convertBooleanToYesNo(pet.healthHistory?.isSkinProblems),
      isTicksFleesTreated: this.convertBooleanToYesNo(pet.healthHistory?.isTicksFleesTreated),
      ticksFleesTreatedDate: pet.healthHistory?.ticksFleesTreatedDate,
      ticksFleesTreatedHowTo: pet.healthHistory?.ticksFleesTreatedHowTo,
      isRecentlyDeWormed: this.convertBooleanToYesNo(pet.healthHistory?.isRecentlyDeWormed),
      recentlyDeWormedDate: pet.healthHistory?.recentlyDeWormedDate,
      isSpecialDietaryRequirements: this.convertBooleanToYesNo(pet.healthHistory?.isSpecialDietaryRequirements),
      specialDietaryRequirementsDescription: pet.healthHistory?.specialDietaryRequirementsDescription,
      isIllLast30Days: this.convertBooleanToYesNo(pet.healthHistory?.isIllLast30Days),
      illLast30DaysExplanation: pet.healthHistory?.illLast30DaysExplanation,
      isDisplayingSymptomsCoughingSneezingUpsetStomach: this.convertBooleanToYesNo(pet.healthHistory?.isDisplayingSymptomsCoughingSneezingUpsetStomach),
      isMedicalConditionsInjuriesIllnesses: this.convertBooleanToYesNo(pet.healthHistory?.isMedicalConditionsInjuriesIllnesses),
      medicalConditionsInjuriesIllnessesDetails: pet.healthHistory?.medicalConditionsInjuriesIllnessesDetails,
      isAllergiesFoodSensitivities: this.convertBooleanToYesNo(pet.healthHistory?.isAllergiesFoodSensitivities),
      allergiesFoodSensitivitiesDetails: pet.healthHistory?.allergiesFoodSensitivitiesDetails,
      image: pet.image,
      imageFileName: pet.imageFileName
    });

    this.vaccinationProofUrl = `${this.apiUrl}${pet.healthHistory?.vaccinationProof}`;
  } // end of patchpetDetailForm

  updatePetDetail() {
    this.isSavingPet = true;
    // this.createPetDetailPayload();
    console.log(`updatePetDetail, petDetailData:${JSON.stringify(this.petDetailData)}`);
    this.petService.updatePet(this.selectedPet.id, this.petDetailData).subscribe({
      next: (response) => {
        this.isSavingPet = false;
        console.log(`updatePetDetail, response: ${JSON.stringify(response)}`);
        this.hideModal(true);
      },
      error: (error) => {
        this.isSavingPet = false;
        console.error(`updatePetDetail, error: ${JSON.stringify(error)}`);
      }
    });
    this.isSavingPet = false;
  } // end of updatePetDetail

  createPet() {
    this.isSavingPet = true;
    // this.createPetDetailPayload();
    console.log(`createPet, petDetailData:${JSON.stringify(this.petDetailData)}`);
    this.petService.createPet(this.petDetailData).subscribe({
      next: (response) => {
        this.isSavingPet = false;
        console.log(`createPet, response: ${JSON.stringify(response)}`);
        this.hideModal(true)
      },
      error: (error) => {
        this.isSavingPet = false;
        console.error(`createPet, error: ${JSON.stringify(error)}`);
        this.hideModal(false)
      }
    });
    this.isSavingPet = false;
  } // end of createPet


  createPetDetailForm() {
    this.petDetailForm = this.formBuilder.group({
      code: '',
      name: '',
      ownerName: '',
      weight: '',
      disease: '',
      vaccine: ''
    });
  } // end of createPetDetailForm

  getOwners() {
    this.isOwnerListLoaded = false;
    this.petService.getOwners().subscribe({
      next: (response) => {
        console.log(`getOwners, response: ${JSON.stringify(response)}`);
        this.ownerList = this.dataMappingService.mapOwnersDetailDataToInterfaces(response);
        this.processOwnerList(response);
        this.isOwnerListLoaded = true;
      },
      error: (error) => {
        this.isOwnerListLoaded = true;
        console.error(`getOwners, error: ${JSON.stringify(error)}`);
      }
    });
  } // end of getOwners

  processOwnerList(response: any) {
    for (const owner of this.ownerList) {
      console.log(`processOwnerList, owner:${JSON.stringify(owner)}`);
      this.ownerNameList.push(`${owner.firstName} ${owner.firstName}`);
      this.ownerFirstNameList.push(owner.firstName);
      this.ownerLastNameList.push(owner.lastName);
    }
  } // end of processOwnerList

  onSelectOwner(event: TypeaheadMatch): void {
    this.selectedOwner = event.item;
    console.log(`onSelectOwner, selectedOwner: ${JSON.stringify(this.selectedOwner)}`);
    console.log(`onSelectOwner, selectedOwner: ${this.selectedOwner.firstName} ${this.selectedOwner.lastName}`);
    this.petDetailForm.get('ownerFirstName')?.setValue(this.selectedOwner.firstName);
    this.petDetailForm.get('ownerLastName')?.setValue(this.selectedOwner.lastName);
  } // end of onSelectOwner



  onSelectOwnerFirstName(event: TypeaheadMatch): void {
    this.selectedOwner = event.item;
    console.log(`onSelectOwnerFirstName, selectedOwner: ${this.selectedOwner.firstName} ${this.selectedOwner.lastName}`);
  } // end of onSelectOwnerFirstName

  onSelectOwnerLastName(event: TypeaheadMatch): void {
    this.selectedOwner = event.item;
    console.log(`onSelectOwnerLastName, selectedOwner: ${this.selectedOwner.firstName} ${this.selectedOwner.lastName}`);
  } // end of onSelectOwnerLastName

  getDiseases() {
    this.petService.getDiseases().subscribe({
      next: (response) => {
        console.log(`getOwners, response: ${JSON.stringify(response)}`);
        this.diseases = response;
        this.availableDiseases = this.diseases;
        // Refresh available diseases
        this.getAvailableDiseases();
      },
      error: (error) => {
        console.error(`getOwners, error: ${JSON.stringify(error)}`);
      }
    });
  } // end of getDiseases

  getAvailableDiseases() {
    let tempDiseases = this.diseases;
    for (var disease of this.selectedDiseases) {
      console.log(`getAvailableDiseases, disease: ${JSON.stringify(disease)}`);
      tempDiseases = tempDiseases.filter(item => item.id != disease.id);
    }
    console.log(`getAvailableDiseases, tempDiseases: ${JSON.stringify(tempDiseases)}`);
    this.availableDiseases = tempDiseases;
  } // end of getAvailableDiseases

  onSelectDisease(event: TypeaheadMatch): void {
    this.selectedDiseases.push(event.item);
    console.log(`onSelectDisease, selectedDisease:${this.selectedDiseases}`);
    // Refresh available diseases
    this.getAvailableDiseases();
  } // end of onSelectDisease

  getVaccines() {
    this.petService.getVaccines().subscribe({
      next: (response) => {
        console.log(`getOwners, response: ${JSON.stringify(response)}`);
        this.vaccines = response;
        this.availableVaccines = this.vaccines;
        this.getAvailableVaccines();        // // let tempVaccines = this.vaccines;
      },
      error: (error) => {
        console.error(`getOwners, error: ${JSON.stringify(error)}`);
      }
    });
  } // end of getVaccines

  getAvailableVaccines() {
    let tempVaccines = this.vaccines;
    for (var vaccine of this.selectedVaccines) {
      console.log(`getAvailableVaccines, vaccine: ${JSON.stringify(vaccine)}`);
      tempVaccines = tempVaccines.filter(item => item.id != vaccine.id);
    }
    console.log(`getAvailableVaccines, tempVaccines: ${JSON.stringify(tempVaccines)}`);
    this.availableVaccines = tempVaccines;
  } // end of getAvailableVaccines

  onSelectVaccine(event: TypeaheadMatch): void {
    this.selectedVaccines.push(event.item);
    console.log(`onSelectVaccine, selectedDisease:${this.selectedVaccines}`);
    // Refresh available vaccines
    this.getAvailableVaccines();
  } // end of onSelectVaccine

  getPetTypes() {
    this.petService.getPetTypes().subscribe({
      next: (response) => {
        console.log(`getPetTypes, response: ${JSON.stringify(response)}`);
        this.petTypes = response;
        // this.selectedPet = this.petTypes.filter(t => t.name=='Dog')[0];
        this.selectedPetType = this.petTypes[0];
        console.log(`getPetTypes, selectedPetType: ${JSON.stringify(this.selectedPetType)}`);
        this.petDetailForm.get('petType')?.setValue(this.selectedPetType);
      },
      error: (error) => {
        console.error(`getPetTypes, error: ${JSON.stringify(error)}`);
      }
    });
  } // end of getPetTypes

  setPetType() {
    console.log(`getPetTypes, petTypes: ${JSON.stringify(this.petTypes)}`);
    this.selectedPetType = this.petTypes[0];
    console.log(`getPetTypes, selectedPetType: ${JSON.stringify(this.selectedPetType)}`);
    this.petDetailForm.get('petType')?.setValue(this.selectedPetType);
  } // end of getPetTypes

  createPetDetailPayload() {
    this.petDetailData = this.dataMappingService.mapPetUpdateDetailFormGroupToFormData(this.petDetailForm);

    // Object.keys(this.petDetailForm.controls).forEach(
    //   (key) => {
    //     console.log(`createPetDetailPayload, key:${key}, value:${this.petDetailForm.controls[key].value}`);
    //     this.petDetailData.set(key, this.petDetailForm.controls[key].value);
    //   }
    // );

    // Add owner ID to payload
    if (this.selectedOwner?.id != undefined) {
      this.petDetailData.set("owner_id", this.selectedOwner.id);
    }

    // Add pet type to payload
    this.petDetailData.set("type_id", this.selectedPetType.id);

    // Add diseases ID to payload
    this.createSelectedDiseasesPayload();
    // Add vaccines ID to payload
    this.createSelectedVaccinesPayload();
  } // end of createPetDetailPayload

  createSelectedDiseasesPayload(): void {
    for (let i = 0; i < this.selectedDiseases.length; i++) {
      this.petDetailData.append('diseases', this.selectedDiseases[i].id);
    }
  } // end of createSelectedDiseasesPayload

  createSelectedDiseasesPayload2(): string[] {
    let vaccines: string[] = [];
    this.selectedDiseases.forEach(
      (disease: Disease) => {
        console.log(`createSelectedDiseasesPayload, disease:${disease.id}`);
        this.petDetailData.append("diseases", disease.id);
      }
    );

    return vaccines;
  } // end of createSelectedDiseasesPayload2

  createSelectedVaccinesPayload(): string[] {
    let vaccines: string[] = [];
    this.selectedVaccines.forEach(
      (vaccine: Vaccine) => {
        console.log(`createSelectedVaccinesPayload, vaccine:${vaccine.id}`);
        this.petDetailData.append("vaccines", vaccine.id);
      }
    );

    return vaccines;
  } // end of createSelectedVaccinesPayload

  deleteVaccine(vaccine: Vaccine) {
    console.log(`deleteVaccine, vaccine:${vaccine.id}`);
    this.selectedVaccines = this.selectedVaccines.filter(item => item.id != vaccine.id);
    console.log(`deleteVaccine, selectedVaccines:${JSON.stringify(this.selectedVaccines)}`);
    // Refresh available vaccines
    this.getAvailableVaccines();
  } // end of deleteVaccine

  addVaccine() {
    let createdVaccine: Vaccine;
    let payload = this.createAddVaccinePayload()
    this.petService.createVaccine(payload).subscribe({
      next: (response) => {
        console.log(`addVaccine, response: ${JSON.stringify(response)}`);
        createdVaccine = response;
        this.selectedVaccines.push(createdVaccine);
        this.getVaccines();       // // let tempVaccines = this.vaccines;
      },
      error: (error) => {
        console.error(`addVaccine, error: ${JSON.stringify(error)}`);
      }
    });
  } // end of addVaccine

  createAddVaccinePayload(): any {
    return {
      "name": this.petDetailForm.controls['vaccineName'].value,
      "note": this.petDetailForm.controls['vaccineName'].value
    }
  } // end of createAddVaccinePayload

  deleteDisease(disease: Disease) {
    console.log(`deleteDisease, disease:${disease.id}`);
    this.selectedDiseases = this.selectedDiseases.filter(item => item.id != disease.id);
    console.log(`deleteDisease, selectedDiseases:${JSON.stringify(this.selectedDiseases)}`);
    // Refresh available diseases
    this.getAvailableDiseases();
  } // end of deleteDisease

  addDisease() {
    let createdDisease: Disease;
    let payload = this.createAddDiseasePayload()
    this.petService.createDisease(payload).subscribe({
      next: (response) => {
        console.log(`addDisease, response: ${JSON.stringify(response)}`);
        createdDisease = response;
        this.selectedDiseases.push(createdDisease);
        this.getDiseases();       // // let tempVaccines = this.vaccines;
      },
      error: (error) => {
        console.error(`addDisease, error: ${JSON.stringify(error)}`);
      }
    });
  } // end of addDisease

  createAddDiseasePayload(): any {
    return {
      "name": this.petDetailForm.controls['diseaseName'].value,
      "note": this.petDetailForm.controls['diseaseName'].value
    }
  } // end of createAddDiseasePayload

  hideModal(result: boolean) {
    this.onClose.next(true);
    this.bsModalRef.hide();
  } // end of hideModal

  closeModal() {
    this.hideModal(false);
  } // end of hideModal

  onSubmit() {
    console.log(`onSubmit`);
  }

  onSelectNationality(event: TypeaheadMatch): void {
    this.selectedNationality = event.item;
    console.log(`onSelectNationality, selectedNationality:${this.selectedNationality}`);
  } // end of onSelectNationality

  onVaccinationProofSelected(event: any) {
    this.selected_vaccination_proof_file = event.target.files[0];
  }

  convertBooleanToYesNo(val: boolean | null): 'yes' | 'no' | null {
    return (val != null ? val === true ? 'yes' : 'no' : null)
  }

  setFormFieldsSelectedValue() {
    this.petDetailForm.get('howDidYouHearAboutGoodPet')?.valueChanges.subscribe(value => {
      this.selectedReferral = value;
    });

    this.petDetailForm.get('sex')?.valueChanges.subscribe(value => {
      console.log(`sex chang, value: ${value}`);
      this.selectedSex = value;
      console.log(`sex chang, value: ${value}, selectedSex: ${this.selectedSex}`);
    });

    this.petDetailForm.get('isFriendly')?.valueChanges.subscribe(value => {
      console.log(`isFriendly chang, value: ${value}`);
      this.selectedIsFriendly = value;
      console.log(`isFriendly chang, value: ${value}, selectedIsFriendly: ${this.selectedIsFriendly}`);
    });

    this.petDetailForm.get('isSensitiveBodyOrPhysicalRestriction')?.valueChanges.subscribe(value => {
      console.log(`isSensitiveBodyOrPhysicalRestriction chang, value: ${value}`);
      this.selectedIsSensitiveBodyOrPhysicalRestriction = value;
      console.log(`isSensitiveBodyOrPhysicalRestriction chang, value: ${value}, selectedIsSensitiveBodyOrPhysicalRestriction: ${this.selectedIsSensitiveBodyOrPhysicalRestriction}`);
    });

    this.petDetailForm.get('isSkinProblems')?.valueChanges.subscribe(value => {
      console.log(`isSkinProblems chang, value: ${value}`);
      this.selectedIsSkinProblems = value;
      console.log(`isSkinProblems chang, value: ${value}, selectedIsSkinProblems: ${this.selectedIsSkinProblems}`);
    });

    this.petDetailForm.get('isTicksFleesTreated')?.valueChanges.subscribe(value => {
      console.log(`isTicksFleesTreated chang, value: ${value}`);
      this.selectedIsTicksFleesTreated = value;
      console.log(`isTicksFleesTreated chang, value: ${value}, selectedIsTicksFleesTreated: ${this.selectedIsTicksFleesTreated}`);
    });

    this.petDetailForm.get('isRecentlyDeWormed')?.valueChanges.subscribe(value => {
      console.log(`PetIsRecentlyDeWormed chang, value: ${value}`);
      this.selectedIsRecentlyDeWormed = value;
      console.log(`isRecentlyDeWormed chang, value: ${value}, selectedIsRecentlyDeWormed: ${this.selectedIsRecentlyDeWormed}`);
    });

    this.petDetailForm.get('isSpecialDietaryRequirements')?.valueChanges.subscribe(value => {
      console.log(`isSpecialDietaryRequirements chang, value: ${value}`);
      this.selectedIsSpecialDietaryRequirements = value;
      console.log(`isSpecialDietaryRequirements chang, value: ${value}, selectedIsSpecialDietaryRequirements: ${this.selectedIsSpecialDietaryRequirements}`);
    });

    this.petDetailForm.get('isIllLast30Days')?.valueChanges.subscribe(value => {
      console.log(`isIllLast30Days chang, value: ${value}`);
      this.selectedIsIllLast30Days = value;
      console.log(`isIllLast30Days chang, value: ${value}, selectedPetIsIllLast30Days: ${this.selectedIsIllLast30Days}`);
    });

    this.petDetailForm.get('isMedicalConditionsInjuriesIllnesses')?.valueChanges.subscribe(value => {
      console.log(`isMedicalConditionsInjuriesIllnesses chang, value: ${value}`);
      this.selectedIsMedicalConditionsInjuriesIllnesses = value;
      console.log(`isMedicalConditionsInjuriesIllnesses chang, value: ${value}, selectedIsMedicalConditionsInjuriesIllnesses: ${this.selectedIsMedicalConditionsInjuriesIllnesses}`);
    });

    this.petDetailForm.get('isAllergiesFoodSensitivities')?.valueChanges.subscribe(value => {
      console.log(`isAllergiesFoodSensitivities chang, value: ${value}`);
      this.selectedIsAllergiesFoodSensitivities = value;
      console.log(`isAllergiesFoodSensitivities chang, value: ${value}, selectedIsAllergiesFoodSensitivities: ${this.selectedIsAllergiesFoodSensitivities}`);
    });
  }

  disableControls() {
    if (!this.hasEditPermission) {
      this.petDetailForm.get('age')?.disable();
      this.petDetailForm.get('isFriendly')?.disable();
      this.petDetailForm.get('isSpayedNeutered')?.disable();
    }
  }

  disableForm() {
    if (!this.hasEditPermission) {
      this.petDetailForm.disable();
    }
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.petDetailForm.patchValue({
        image: file,
        imageFilename: file.name
      });

      // Preview logic
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.previewUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  uploadPetImage() {
    console.log(`uploadPetImage`);
    const formData = new FormData();
    // formData.append('name', this.petDetailForm.get('name')?.value);
    const file = this.petDetailForm.get('image')?.value;
    if (file) {
      formData.append('image', file);
    }

    this.showSuccessToast('Uploading pet image', 'Pet');

    this.petService.uploadPetImage(this.selectedPet.id, formData).subscribe({
      next: (response) => {
        console.log(`uploadPetImage, response: ${JSON.stringify(response)}`);
        this.showSuccessToast('Pet image uploaded', 'Pet');
      },
      error: (error) => {
        console.error(`addDisease, error: ${JSON.stringify(error)}`);
      }
    });

    // this.http.post('/api/pets/', formData).subscribe();
  }

  showErrorToast(error: string, title: string) {
    this.toastr.clear();
    this.toastr.error(error, title, environment.toastrConfig);
  }

  showSuccessToast(message: string, title: string) {
    this.toastr.clear();
    // this.toastr.success(message, title, environment.toastrConfig);
    this.toastr.success('message', 'title', {
      timeOut: 3000, // Time to close the notification in milliseconds
      progressBar: true, // Show a progress bar
      positionClass: 'toast-top-right' // Position of the notification
    });
  }
}
